<ng-container *ngIf="radioGroup">
  <fieldset idOrDefault class="radio-group">
    <legend
      idOrDefault
      class="legend-caption"
      *ngIf="label ?? radioGroup.label"
    >
      {{ label ?? radioGroup.label }}
    </legend>
    <div class="radio-error-text">
      <nibtravel-validation
        [validations]="validations"
        [control]="ngControl.control"
        [host]="formComponent"
        [errorMessageOnFormGroup]="errorMessageOnFormGroup"
        [enableDistinctUntilChanged]="enableDistinctUntilChanged"
        (errorEmitter)="error.emit($event)"
        *ngIf="validations"
      ></nibtravel-validation>
    </div>

    <div class="radio-items">
      <div idOrDefault *ngFor="let item of radioGroup.data" class="radio-item">
        <input
          type="radio"
          class="radio-input"
          [attr.data-e2e]="item.e2eId"
          [idOrDefault]="item.inputId"
          [attr.name]="radioGroup.groupName"
          [attr.value]="item.value"
          [required]="required"
          [checked]="item.checked || item.value === value"
          (click)="onChange($event.target.value)"
        />
        <label
          *ngIf="item.label"
          class="radio-label"
          [for]="item.inputId"
          [idOrDefault]="item.labelId"
          [attr.aria-label]="item.label"
        >
          <span idOrDefault class="radio-button"></span>
          <span class="radio-text">
            {{ item.label }}
          </span>
        </label>
      </div>
    </div>
  </fieldset>
</ng-container>
